// Cliente de la API real (badminton-api). Todo el front pasa por aquí desde
// que se migraron Equipos, Competición y Temporadas — ya no queda ninguna
// pantalla contra database.json.
//
// Los endpoints de la API real devuelven { error, codigo } en los fallos;
// aquí se adjuntan como `estado`/`codigo` en el Error para que cada pantalla
// pueda mostrar el mensaje en castellano en vez de uno genérico.
export const REAL_BASE_URL = 'https://api.badminton-fmds.info';

const realRequest = async (path, options = {}) => {
  const res = await fetch(`${REAL_BASE_URL}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  const cuerpo = await res.json().catch(() => null);
  if (!res.ok) {
    const error = new Error(cuerpo?.error || `Error ${res.status}`);
    error.estado = res.status;
    error.codigo = cuerpo?.codigo;
    throw error;
  }
  return cuerpo;
};

export const realApi = {
  get: (path) => realRequest(path),
  post: (path, data) => realRequest(path, { method: 'POST', body: data !== undefined ? JSON.stringify(data) : undefined }),
  patch: (path, data) => realRequest(path, { method: 'PATCH', body: JSON.stringify(data) }),
  put: (path, data) => realRequest(path, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (path) => realRequest(path, { method: 'DELETE' }),
};
